import { render } from "./Representantes.vue?vue&type=template&id=ce668318&scoped=true"
import script from "./Representantes.vue?vue&type=script&lang=js"
export * from "./Representantes.vue?vue&type=script&lang=js"

import "./Representantes.vue?vue&type=style&index=0&id=ce668318&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce668318"]])

export default __exports__